const config = {
  theme: {
    default: "light", // or dark
    sidebar: {
      default: "light", // or dark
    },
    header: {
      default: "light", // or dark
    },
  },
  i18n: {
    defaultLanguage: "pt-PT",
    supportedLanguages: ["en", "pt-PT"],
  },
  layout: {
    sidebar: {
      collapsed: false,
      width: 260,
    },
    header: {
      visible: true,
      fixed: false,
    },
    footer: {
      visible: true,
    },
  },
  formatting: {
    currency: [{ name: "EUR", language: "pt-PT" }],
  },
};

export default config;
